import * as React from 'react';
import { SVGProps } from 'react';

const SvgPoorConnectivityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.046 3.046a.75.75 0 0 0 0 1.06l16.847 16.848a.75.75 0 1 0 1.06-1.06L4.108 3.045a.75.75 0 0 0-1.06 0Zm.256 6.303a13.888 13.888 0 0 1 2.175-1.432l1.356 1.356c-.847.401-1.65.902-2.391 1.497a.91.91 0 0 1-1.14-1.42Zm2.066 3.625A9.79 9.79 0 0 1 8.57 11.01l1.451 1.451a7.969 7.969 0 0 0-3.42 1.854.91.91 0 1 1-1.233-1.34Zm7.503-2.543 2.563 2.563a7.968 7.968 0 0 1 1.927 1.297.91.91 0 1 0 1.227-1.346 9.79 9.79 0 0 0-5.717-2.514Zm2.391 7.271L12.05 14.49h-.057a5.698 5.698 0 0 0-1.752.277c-.852.276-1.63.75-2.267 1.386a.91.91 0 1 0 1.286 1.29 3.878 3.878 0 0 1 3.66-1.019c.683.17 1.308.521 1.807 1.019.15.15.34.236.535.259ZM9.048 6.608l1.582 1.583a12.07 12.07 0 0 1 8.928 2.584.91.91 0 0 0 1.14-1.42 13.89 13.89 0 0 0-11.65-2.747Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPoorConnectivityIcon;
